'use strict';
import React from 'react';
import { TweenMax, TimelineMax, EasePack, TextPlugin} from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import settings from '../../util/settings';
import ReactGA from 'react-ga';
import Feature from '../../components/Feature/Feature';
import Button from '../../components/Button/Button';
import Title from '../../components/Title/Title';

class Mission extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      analyticsSubmitted: {
        scroll: false
      }
    }
    this.ASSET_PATH = settings.ASSET_PATH + "images/";
    this.AnimationElements = []
  }

  componentDidMount() {
    TweenMax.to(this.container, 0.5, {autoAlpha: 1});
    TweenMax.set(this.AnimationElements, {autoAlpha: 0});
    this.props.refSetter(this.container)
    window.addEventListener('scroll', this.handleScroll);
    window.setTimeout(this.handleScroll, 100);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    TweenMax.set(this.container, {autoAlpha: 0});
  }
  handleInputChange = (e, item)=>{

  }
  handleScroll = (e) => {
    if (this.container.getBoundingClientRect().top < window.innerHeight && !this.state.analyticsSubmitted.scroll) {
      ReactGA.modalview('work');
      this.setAnalyticSubmission('scroll')
    }
    if (this.container.getBoundingClientRect().top <= window.innerHeight/2) {
      this.animateIn();
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
  setAnalyticSubmission = (name) => {
    if (name) {
      this.setState({analyticsSubmitted: {...this.state.analyticsSubmitted, [name]: true}})
    }
  }
  animateIn = () => {
    var tl = new TimelineMax({paused: true});
    tl.staggerFromTo(this.AnimationElements, 1.5, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, ease: Expo.easeOut}, 0.5);
    tl.play();
  }
  appendElement = (el) => {
    if (el) this.AnimationElements.push(el)
  }
  render() {
    this.AnimationElements = []

    return <div
      id="section-mission"
      ref={el => this.container = el}
    >
      <div className="ContentContainer">
        <Title title="MISSION" subtitle="Our values and mission are what sets us apart" light />
        <div className="row flex-center">
          <div className="col-md-6 mission-statement">
            <p>At Metals & Alloys Centre, we strive to provide the best customer service, to go above and beyond what is expected, to ensure all of our promises to our customers are fulfilled in a timely manner, to supply all of your metal needs as well as providing extra services in machining & fabrications.</p>
          </div>
          <div className="col-md-6 other-info">
            <img src={this.ASSET_PATH + "brand-large.png"} alt="Metals & Alloys Centre Logo" className="logo-large"/>
            <div className="btn-container">
              <Button title="CALL US TODAY" dark icon="phone" mirrored link="tel:+19056603386"/>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
};

Mission.defaultProps = {
  windowWidth: 960,
  windowHeight: 570
};

export default Mission;



// WEBPACK FOOTER //
// ./sections/Mission/Mission.js